import styled from "styled-components";

export const Container = styled.div`
  position: relative;
  height: 52px;
  width: ${({ width }) => (width ? width : "100")}%;

  select:focus {
    border: 1px solid ${({ error }) => (error ? "red" : "#2775FF")};
  }

  .iconArrowDown {
    position: absolute;
    right: 10px;
    top: 20px;
  }
`;

export const Label = styled.label`
  position: absolute;
  top: -9px;
  left: 12.5px;
  font-size: 13px;
  padding: 2px 5px;
  z-index: 10;
  font-weight: 500;
  background-color:  #fff;
  color: ${({ error }) => (error ? "red" : "#000")};
`;

export const InputSelect = styled.select`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  outline: none;
  background: none;
  font-size: 14px;
  color: #272727;
  border-radius: 4px;
  border: 1px solid ${({ error }) => (error ? "red" : "#b2b2b2")};
  padding: 0 10px;
  z-index: 1;

  &::placeholder {
    font-weight: 200;
  }
`;

export const InputSelectItem = styled.option`
  width: 90%;
  font-size: 13.5px;
  color: #272727;
`;
